var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define('baseline/translate',["require", "exports", "../dom", "../geo/geocoder", "../maps/basemap", "../maps/layers/focuslayer", "../maps/layers/translatedlayer", "../places/place-autocomplete", "../tracks/track-store", "../util/log"], function (require, exports, dom_1, geocoder_1, basemap_1, focuslayer_1, translatedlayer_1, placeAutocomplete, trackStore, log) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    // Tools to help re-locate a track from one place to another
    var inputDestination;
    var inputRotation;
    var inputError;
    var link;
    var map;
    var mapFocus;
    var trackLayer;
    function init(trackId, userId) {
        placeAutocomplete.init(userId);
        inputDestination = document.getElementById("relocate-destination");
        inputRotation = document.getElementById("relocate-rotation");
        inputError = document.getElementById("relocate-error");
        link = document.getElementById("relocate-download");
        if (!inputDestination)
            return;
        // On key press, update the link so that right click save as works
        inputDestination.onchange = function () { return onInput(false); };
        inputDestination.onkeyup = function () { return onInput(false); };
        inputRotation.onchange = function () { return onInput(false); };
        inputRotation.onkeyup = function () { return onInput(false); };
        // On click and unfocus, validate errors
        link.onclick = function () { return submit(); };
        $("#modal-relocate").on("shown.bs.modal", function () {
            log.info("track relocate modal");
            inputDestination.focus();
            // Load map on modal open
            if (!map) {
                map = new basemap_1.BaseMap({});
                map.initGoogle((0, dom_1.q)(".relocate-map")[0]);
                map.addLayer(mapFocus = new focuslayer_1.FocusLayer());
                trackStore.getTrackData(trackId).then(function (track) {
                    map.addLayer(trackLayer = new translatedlayer_1.TranslatedLayer(track));
                    trackLayer.update();
                });
            }
        });
        document.getElementById("relocate-form").onsubmit = function () {
            submit();
            return false;
        };
    }
    exports.init = init;
    // Called when text box changes
    function onInput(submitted) {
        // Reset UI
        showError(undefined);
        // Try and parse location
        try {
            var destination = (0, geocoder_1.parseLatLngAlt)(inputDestination.value);
            var rotation = Number(inputRotation.value);
            if (isNaN(rotation)) {
                rotation = 0;
            }
            updateLocation(destination, rotation);
        }
        catch (e) {
            updateLocation(undefined, 0);
            // Don't show errors until user tried clicking or hit enter
            if (submitted) {
                // Show errors
                inputDestination.parentElement.classList.add("has-error");
                inputError.innerText = e.message;
            }
        }
    }
    function updateLocation(destination, rotation) {
        if (destination) {
            // Set link to custom
            link.href = window.location.pathname + "/kmz/translate?" + params(__assign({ rot: rotation }, destination));
            // Update map
            map.setCenter(destination);
            map.googleMap.setZoom(14);
            mapFocus.setFocus(destination);
            trackLayer.setTranslate(destination, rotation);
            trackLayer.update();
        }
        else {
            link.removeAttribute("href");
            mapFocus.setFocus(undefined);
        }
    }
    function showError(error) {
        if (error) {
            inputDestination.parentElement.classList.add("has-error");
            inputError.innerText = error;
        }
        else {
            inputError.innerText = "";
            inputDestination.parentElement.classList.remove("has-error");
        }
    }
    // Convert object to query params
    // {a: 1, b: 2} -> "a=1&b=2"
    function params(obj) {
        return Object.keys(obj).map(function (k) { return k + "=" + obj[k]; }).join("&");
    }
    function submit() {
        onInput(true);
        // Focus if error
        try {
            (0, geocoder_1.parseLatLngAlt)(inputDestination.value);
            // Click button on behalf of user
            link.click();
        }
        catch (e) {
            inputDestination.focus();
        }
    }
});
//# sourceMappingURL=/assets/javascripts/baseline/translate.js.map;
